import type { FC } from 'react';

import { t } from '@luna/i18n';
import type { ServerErrorValues } from '@luna/form2';
import { useFormContext } from '@luna/form2';

interface Props {
    id: string;
    isLive: boolean;
}

export const A11YErrorInfo: FC<Props> = ({ id, isLive }) => {
    const { errors } = useFormContext<ServerErrorValues>();
    const numberOfErrors = Object.keys(errors).length;

    const ariaLive = isLive ? 'polite' : 'off';

    return (
        <div className="sr-only" id={id} aria-live={ariaLive}>
            {numberOfErrors > 0 && t('form.errorAnnouncement_a11y', { count: numberOfErrors })}
            {numberOfErrors > 0 && Object.values(errors)}
        </div>
    );
};
